<template>
  <div>
    <label>{{ exampleQuestionText }}</label>
    <a-textarea :auto-size="{ minRows: type === 'text' ? 2 : 8 }" :key="type" />
    <QuestionSettings
      v-if="questionSettings"
      @editItem="editItem"
      @deleteTempQuestion="$emit('deleteTempQuestion')"
      @setAsScreener="$emit('setAsScreener', $event)"
      @saveInLibrary="$emit('saveInLibrary', $event)"
      @addSavedQuestion="$emit('addSavedQuestion')"
      :langObj="langObj"
      :setAsScreener="setAsScreener"
      :showSetAsScreener="showSetAsScreener"
      :saveInLibrary="saveInLibrary"
      :showSaveInLibrary="showSaveInLibrary"
      :hideEditButton="hideEditButton"
      :hideAddButton="hideAddButton"
      :insertCustomQuestionsLoading="insertCustomQuestionsLoading"
    ></QuestionSettings>
  </div>
</template>

<script>
import QuestionSettings from "@/components/questions/QuestionSettings.vue";

export default {
  name: "TextTypeExample",
  props: {
    exampleQuestionText: {
      type: String,
    },
    index: {
      type: Number,
    },
    langObj: {
      type: Object,
    },
    questionType: {
      type: String,
    },
    questionSettings: {
      type: Boolean,
    },
    setAsScreener: {
      type: Boolean,
    },
    showSetAsScreener: {
      type: Boolean,
    },
    type: {
      type: String,
      default() {
        return "text";
      },
    },
    saveInLibrary: {
      type: Boolean,
    },
    showSaveInLibrary: {
      type: Boolean,
    },
    hideEditButton: {
      type: Boolean,
    },
    hideAddButton: {
      type: Boolean,
    },
    insertCustomQuestionsLoading: {
      type: Boolean,
    },
  },
  components: {
    QuestionSettings,
  },
  data() {
    return {};
  },

  methods: {
    editItem() {
      let info = {
        index: this.index,
        questionType: this.questionType,
      };

      this.$emit("editQuestion", info);
    },
  },
};
</script>

<style lang="scss" scoped></style>
